module.exports = __webpack_public_path__ + "img/builder-37.25402bd7.jpg";